import { usePost } from "seed/api";
import { ColumnTypes } from "components/collections/util/datatypes";

const ColumnActions = ({
  activeCollectionId,
  pushOperationQueue,
  totalPages,
  setSearch,
  setFilters,
  setQuery,
  setSorting,
  setPageNum,
  setLastFilterDate,
  setColumns,
  setPrimaryKey,
  setCollectionOptions,
}) => {

  const [callGetCollectionData] = usePost("/collections/get_data", {
		onCompleted: (data) => {

      if (Array.isArray(data)) {

        const options = data.reduce((acc, item) => {
          acc[item.collection.id] = item;
          return acc;
        }, {});

        setCollectionOptions((prevOptions) => ({
          ...prevOptions,
          ...options
        }));

      }
      else {
        
        setCollectionOptions((prevOptions) => ({
          ...prevOptions,
          [data.collection.id]: data.data
        }));

      }

		}	
	});

  const setCollectionColumns = (collection) => {
      
      if (collection && collection.schema) {
          
          let schema = {};
          try { schema = JSON.parse(collection.schema) ?? {} }
          catch (e) { schema = (collection.schema) ?? {} }
    
          const sortedColumns = Object.assign([], schema.structure || []).sort((a, b) => {
            if (!schema.primary_key) return 0;
            if (a.internal) return 0;
            if (b.internal) return 0;
            if (a.name === schema.primary_key) return -1;
            if (b.name === schema.primary_key) return 1;
            return 0;
          });
    
          setColumns(sortedColumns || []);
          setPrimaryKey(schema.primary_key || []);
    
      }

  }

  const setForeignCollectionOptions = (columns) => {

    const collectionIds = [];

    for(const column of columns) {
			if (column.type == ColumnTypes.COLLECTION) {
				collectionIds.push(column.structure.collection_id);
			}
		}

    callGetCollectionData({
      collection_ids: Array.from(new Set(collectionIds)),
      page_size: 50,
      page_number: 1
    });

  }

  const updateSearch = (value) => {
    localStorage.setItem("collection_search_" + activeCollectionId, value)
    setSearch(value);
  }

  const updateFilters = (value) => {
    localStorage.setItem("collection_filters_" + activeCollectionId, JSON.stringify(value))
    setFilters(value);
    setLastFilterDate(new Date().toISOString());
  }

  const updateQuery = (value) => {
    localStorage.setItem("collection_query_" + activeCollectionId, value)
    setQuery(value);
    setLastFilterDate(new Date().toISOString());
  }

  const updateSorting = (value) => {
    localStorage.setItem("collection_sorting_" + activeCollectionId, JSON.stringify(value))
    setSorting(value);
  }

  const updatePage = (page) => {
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    localStorage.setItem("collection_page_" + activeCollectionId, page)
    setPageNum(page);
  }

  const pushColumnOperation = (actions) =>
    pushOperationQueue({ actions, type: "schema", collection_id: activeCollectionId });

  return {
    setCollectionColumns,
    setForeignCollectionOptions,
    updateSearch,
		updateFilters,
		updateQuery,
		updateSorting,
		updatePage,
    pushColumnOperation
  }
  
}

const RowActions = ({
  activeCollectionId,
  pushOperationQueue,
  setRows,
}) => {

  const setCollectionRows = (collectionRows, sorting) => {

    if (!collectionRows) return;

		const sortedData = Object.values(collectionRows || []);
		if(sorting.length == 0) sortedData.sort((a, b) => a.folio - b.folio);

		const data = sortedData.map(d => ({
			data: function () {
				try { return JSON.parse(d.data) ?? {} }
				catch (e) { return (d.data) ?? {} }
			}(),
			folio: d.folio,
			id: d.id,
		}));

		setRows(data);

  }

  const pushRowOperation = (actions) =>
    pushOperationQueue({ actions, type: "data", collection_id: activeCollectionId });

  return {
    setCollectionRows,
    pushRowOperation
  }

}

export {
  ColumnActions,
  RowActions
}